import { Box, Typography } from "@mui/material";
import React from "react";

export default function AuthFooter() {
  return (
    <Box
      sx={{
        backgroundColor: {
          md: "background.default",
          width: "fit-content",
          marginX: "auto",
        },
        padding: "8px",
        borderRadius: "4px",
      }}
    >
      <Typography
        sx={{
          fontFamily: "IrSans",
          margin: "auto",
          backgroundColor: {
            md: "background.default",
            width: "fit-content",
          },
        }}
        variant="body2"
        color="textSecondary"
        align="center"
      >
        © 2024 - تمام حقوق برای این نرم افزار محفوظ و متعلق به{" "}
        <Typography component="span" variant="body2" color="secondary.main">
          شرکت کارن ترابر خلیج فارس
        </Typography>{" "}
        می‌باشد.
      </Typography>
    </Box>
  );
}
